import { render, staticRenderFns } from "./CircleScratched.vue?vue&type=template&id=3f82c128&"
import script from "./CircleScratched.vue?vue&type=script&lang=ts&"
export * from "./CircleScratched.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports